import { useCallback } from "react";

import { GenericObject } from "@/utils/types";
import { useActiveStore } from "@/store/activePages";
import { useFormStore } from "@/store/form";
import { useNavigate } from "react-router-dom";

const usePageSubmit = (
  nextRoute: string,
  callback?: (newData: GenericObject) => Promise<void> | void
) => {
  const addPage = useActiveStore((store) => store.addPage);
  const addData = useFormStore((store) => store.addData);
  const navigate = useNavigate();

  return useCallback(
    async (newData: GenericObject) => {
      await callback?.(newData);
      addData(newData);
      addPage(nextRoute);
      navigate(nextRoute);
    },
    [callback, addData, addPage, nextRoute, navigate]
  );
};

export default usePageSubmit;
